import { makeStyles } from '@material-ui/styles';

import { MainButton } from '@bizzabo/design-system';
import { UserPreview } from '@bizzabo/entities';

import { ScheduledMeeting } from '../../types';
import ManageMeetingCard from '../ManageMeetingCard';
import MeetingItem from '../MeetingItem';
import useTypeTracking from '../../../../analytics';
import UserBadgeAction from '../UserBadgeAction';
import { useMeetings } from '../../MeetingsTool/MeetingsToolContext';

interface MeetingInvitesItemProps {
    meeting: ScheduledMeeting;
    user: UserPreview;
}

const MeetingInvitesItem: React.FC<MeetingInvitesItemProps> = ({ meeting, user }) => {
    const { openMeetingInvitation } = useMeetings();

    const { trackClickEvent } = useTypeTracking();
    const classes = useStyles();

    const onRespond = () => {
        openMeetingInvitation({ meetingId: meeting.id });
        trackClickEvent({
            subCategory: 'RESPOND_MEETING',
            description: {
                meeting_id: meeting.id,
                location: 'MEETING_CARD',
                flow: 'REVIEW_INVITATION',
                meeting_participant_role: 'GUEST',
            },
        });
    };

    return (
        <ManageMeetingCard>
            <MeetingItem>
                <UserBadgeAction user={user} hasNotification={!!meeting.notifications?.length}>
                    <MainButton onClick={onRespond} className={classes.btn}>
                        Respond
                    </MainButton>
                </UserBadgeAction>
            </MeetingItem>
        </ManageMeetingCard>
    );
};

const useStyles = makeStyles(
    theme => ({
        btn: {
            ...theme.typography.t81,
            padding: '2px 12px',
        },
    }),
    { classNamePrefix: 'meetings-manage-invite-item' }
);

export default MeetingInvitesItem;
